import { ComponentChild, FunctionalComponent } from 'preact'
import Icon from '../assets'
import CSSTransitionGroup from 'preact-css-transition-group'

export interface SliderProps {
  title: string
  open: boolean
  trigger: ComponentChild
  onToggle: (isOpen: boolean) => void
}

const Slider: FunctionalComponent<SliderProps> = ({ open, onToggle, trigger, title, children }) => (
  <div className='slider-menu'>
    <span className='slider-trigger' onClick={() => onToggle(true)}>
      {trigger}
    </span>
    <CSSTransitionGroup
      transitionName='slide-right'
      transitionEnterTimeout={150}
      transitionLeaveTimeout={150}
    >
      {open && (
        <div className='slider-content'>
          <div className='slider-header'>
            <Icon width={21} height={21} icon='close' onClick={() => onToggle(false)} />
            <div className='slider-title text-center'>{title}</div>
          </div>
          {children}
        </div>
      )}
    </CSSTransitionGroup>
  </div>
)
export default Slider
